import React from "react";

/**
 * MiniSparkline — tiny inline bar chart for stat cards.
 *
 * Props:
 *   data   number[]   — array of values (up to 24)
 *   color  string     — bar color (hex)
 *   height number     — height in px (default 28)
 */
function MiniSparkline({ data = [], color = "#185FA5", height = 28 }) {
  if (!data.length) return null;
  const max = Math.max(...data, 1);
  return (
    <div style={{ display: "flex", alignItems: "flex-end", gap: 2, height, marginTop: 6 }}>
      {data.map((v, i) => (
        <div
          key={i}
          style={{
            flex: 1,
            height: `${Math.max(Math.round((v / max) * (height - 4)) + 2, 2)}px`,
            background: color,
            borderRadius: "2px 2px 0 0",
            opacity: i === data.length - 1 ? 1 : 0.55 + (i / data.length) * 0.45,
          }}
        />
      ))}
    </div>
  );
}

export default MiniSparkline;
